export default "__VITE_ASSET__3f39d7c2__"